'use strict';

import { view } from '@/functions';

const prefix = '/pos-rental-fees';

export default [
    {
        path: prefix,
        name: 'pos-rental-fees',
        meta: {
            title: 'POS rental fees',
            scopes: ['read_pos_information', 'write_pos_information']
        },
        component: () => view('pos-rental-fees/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'pos-rental-fees-info',
        meta: {
            title: 'POS rental fees',
            scopes: ['read_pos_information', 'write_pos_information']
        },
        component: () => view('pos-rental-fees/info'),
    },
];
